import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParamsAndBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { WORKFLOW_ID_PATTERN } from "@constants/url-parameter-patterns";
import { WorkflowDetailsConfigurationRpServiceWorkflow } from "@idw-types/data/workflow-details-configuration";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export type CreateWorkflowVerificationServiceResponse = {
    axnAdminRPService: RpServiceConfiguration;
    axnAdminRPServiceWorkflow: WorkflowDetailsConfigurationRpServiceWorkflow;
    id: string;
}

export const createWorkflowVerificationServiceRequest = async (
    rpServiceTemplateId: string,
    sourceRPServiceID: string,
    body: Record<string, any>,
    workflowId: string
): Promise<GenericNetworkResponse<CreateWorkflowVerificationServiceResponse>> => {
    const route = injectCustomIdParameter(apiRoutes.serviceConfiguration.rpServiceConfig.workflow.addService, workflowId, WORKFLOW_ID_PATTERN);
    const queryParameters = [];
    if (rpServiceTemplateId) {
        queryParameters.push({
            parameter: "rpServiceTemplateID",
            value: rpServiceTemplateId
        });
    } else if (sourceRPServiceID) {
        queryParameters.push({
            parameter: "sourceRPServiceID",
            value: sourceRPServiceID
        });
    }

    const { data, error } = await handleRequestWithQueryParamsAndBody(RequestTypes.POST, route, queryParameters, body);
    return { data, error, queryParameters, body };
};